import requestProvider from "./axiosHandler";

const getAllCustomer = () => {

    return requestProvider
        .get("/customer/get-all")
}

const createCustomer = (list) => {
    return requestProvider
        .post(`/customer`, {
            name: list.name,
            description: list.description,
            email: list.email,
            website: list.website,
            fax: list.fax,
            sector: list.sector,
            internalPhone: list.internalPhone,
            mobilePhone: list.mobilePhone,
            taxNo: list.taxNo,
            taxOffice: list.taxOffice,
            cargoCompany: list.cargoCompany
        })
}

const updateCustomer = (list) => {

    return requestProvider
        .put(`/customer`, {
            name: list.name,
            description: list.description,
            email: list.email,
            website: list.website,
            fax: list.fax,
            sector: list.sector,
            internalPhone: list.internalPhone,
            mobilePhone: list.mobilePhone,
            taxNo: list.taxNo,
            taxOffice: list.taxOffice,
            id: list.id,
            cargoCompany: list.cargoCompany
        })
}

const deleteCustomer = (id) => {

    return requestProvider
        .delete(`/customer/${id}`)
}

const getCustomerById = (id) => {

    return requestProvider
        .get(`/customer/${id}`)
}

const filterCustomer = (list) => {
    return requestProvider
        .post('customer/filter', list)
}

const createCustomerBulk = (list) => {
    return requestProvider
        .post('customer/create-all', list)
}

const getCustomerAsSelect = () => {
    return requestProvider
        .get('customer/select');
};

const getCustomersWithPage = (list) => {
    return requestProvider
        .post('customer/page-filter', list)
};

export {
    filterCustomer,
    getAllCustomer,
    createCustomer,
    updateCustomer, 
    deleteCustomer, 
    getCustomerById, 
    createCustomerBulk,
    getCustomerAsSelect,
    getCustomersWithPage
}